import { render, staticRenderFns } from "./IconYandex.vue?vue&type=template&id=368d4600&"
import script from "./IconYandex.vue?vue&type=script&lang=js&"
export * from "./IconYandex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports